export default "__VITE_ASSET__8925363c__"